import { useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { setlatestDealVersion } from 'cache/latest-deal-info'
import GET_LATEST_DEAL_VERSION, {
  IGetLatestDealVersionRequest,
  IGetLatestDealVersionResponse,
} from 'queries/getLatestDealVersion'

export const useLatestDealVersion = () => {
  const { dealNumber } = useParams<{ dealNumber: string }>()

  const [getLatestDealVersion, { data, loading, error }] = useLazyQuery<
    IGetLatestDealVersionResponse,
    IGetLatestDealVersionRequest
  >(GET_LATEST_DEAL_VERSION)

  const handleGetLatestDealVersion = async () => {
    try {
      await getLatestDealVersion({
        variables: {
          dealNumber: parseInt(dealNumber),
        },
      })
    } catch (error) {
      return { error }
    }
  }

  if (data?.latestDeal?.currentVersionFlag === 'Y') {
    setlatestDealVersion(data)
  }

  return {
    getLatestDealVersion: handleGetLatestDealVersion,
    data,
    loading,
    error,
  }
}
